import React from 'react';
import PropTypes from 'prop-types';
import { Div } from '@pinpoint/design-kit';

function Progress({ currentPage, totalPages }) {
  return (
    <Div
      p={{ x: '1rem', y: '.625rem' }}
      m={{ t: '.5rem' }}
      w="100%"
      d="flex"
      justify="center"
      align="center"
      bg="white"
      rounded="md"
    >
      {new Array(totalPages).fill(true).map((_, index) => (
        <Div
          h="1rem"
          maxH="1rem"
          maxW="4.75rem"
          w={`calc(100%/${totalPages})`}
          border="2px solid #FFFFFF"
          bg={index <= currentPage ? 'progressTeal' : 'shadeBD'}
        />
      ))}
    </Div>
  );
}

Progress.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
};

export default Progress;
